export default __webpack_public_path__ + "static/media/x-icon.a59455a1.svg";